// extracted by mini-css-extract-plugin
var _1 = "UmfdZ";
export { _1 as "messageBar" }
